<script lang="ts">
    import type { Price } from '@shared/types/types';

    export type UvpMode = 'statusQuo' | 'defensive' | 'strike' | 'red' | 'strikeRed';

    /*                                                                                        */
    interface Props {
        price: Price;
        uvpMode?: UvpMode;
    }

    let { price, uvpMode = 'statusQuo' }: Props = $props();

    const showUvp = $derived(
        uvpMode === 'statusQuo' ? price.sale && !!price.suggestedRetailPrice : !!price.suggestedRetailPrice,
    );
    const strikethrough = $derived(uvpMode === 'statusQuo' || uvpMode === 'strike' || uvpMode === 'strikeRed');
</script>

{#if showUvp}
    <span class="oc-copy-75"
        >UVP <span class={['reptile-price__priceValue', strikethrough && 'reptile-price__priceValue--strikethrough']}
            >{price.suggestedRetailPrice} €</span
        ></span
    >
{:else if uvpMode === 'statusQuo' && price.sale && price.comparativePrice}
    <span class={['reptile-price__priceValue', 'reptile-price__priceValue--strikethrough', 'oc-copy-75']}
        >{price.comparativePrice} €</span
    >
{/if}

<style lang="scss">
    .reptile-price {
        &__priceValue {
            white-space: nowrap;

            &--strikethrough {
                text-decoration: line-through;
            }
        }
    }
</style>
